//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import Cuid from '@models/Cuid';
import IItemMetadata from '@models/IItemMetadata';
import { isDefined } from '@utils/filterPredicates';
import { pluralize } from '@utils/stringUtils';

export const getCuidsWithRightsExpirySet = (
  allCuidsMetadata: Record<Cuid, IItemMetadata>,
  cuidsToCheck: Cuid[],
): Cuid[] => {
  return cuidsToCheck.filter((cuid: Cuid) => {
    const metadata = allCuidsMetadata[cuid];

    return (
      isDefined(metadata?.rightsPermissions?.expirationTime) ||
      !!metadata?.rightsPermissions?.isRightsExpired
    );
  });
};

export const getSyndicationWarningText = (
  numberOfCuidsSelected: number,
  numberOfCuidsWithExpiry: number,
): string => {
  const eligibleCuids = numberOfCuidsSelected - numberOfCuidsWithExpiry;
  if (eligibleCuids === 0) {
    return `The selected ${pluralize(numberOfCuidsSelected, 'item', 'items', false)} can't be distributed to Visual Syndication Network as ${numberOfCuidsSelected > 1 ? 'they have' : 'it has'} rights that expire.`;
  }
  return `Only ${eligibleCuids} of the ${numberOfCuidsSelected} selected items can be distributed to Visual Syndication Network, as the ${pluralize(numberOfCuidsWithExpiry, 'other has', 'others have', false)} rights that expire.`;
};
